<template>
    <ErrorMessage v-if="loadingError"
                  :error="loadingError" />

    <PageLoadingSpinner v-if="loading" />
    <PaymentTokenList v-else-if="paymentTokens.length > 0"
                      :payment-tokens="paymentTokens"
                      :selectable="selectable"
                      :selected-payment-token="selectedPaymentToken"
                      @update:selected-payment-token="$emit('update:selectedPaymentToken', $event)" />
    <div v-else
         class="alert alert-info">
        {{ l('GOCARDLESS.NO_MANDATES') }}
    </div>
</template>

<script>
import ErrorMessage from '@/vue/components/Errors/ErrorMessage';
import PageLoadingSpinner from '@/vue/components/PageLoadingSpinner';
import PaymentTokenList from '@/epos/vue/components/Payment/PaymentTokenList';
import { container } from '@/container';
import { sortByID } from '@/functions/arraySorting';

export default {
    components: {
        PaymentTokenList,
        PageLoadingSpinner,
        ErrorMessage,
    },

    props: {
        customerAccountID: {
            type: Number,
            required: true,
        },

        /**
         * @type {?PaymentToken}
         */
        selectedPaymentToken: {
            type: Object,
            default: null,
        },

        selectable: {
            type: Boolean,
            default: false,
        },
    },

    emits: ['update:selectedPaymentToken'],

    data() {
        return {
            /**
             * @type {boolean}
             */
            loading: true,

            /**
             * @type {?Error}
             */
            loadingError: null,

            /**
             * @type {PaymentToken[]}
             */
            paymentTokens: [],
        };
    },

    created() {
        this.loadPaymentTokens();
    },

    methods: {
        async loadPaymentTokens() {
            this.loadingError = null;
            this.loading = true;
            try {
                let paymentTokens = await container.goCardlessService
                    .loadPaymentTokens(this.customerAccountID);

                // Sort by ID descending (newest at the top).
                sortByID(paymentTokens);
                this.paymentTokens = paymentTokens.reverse();
            } catch (err) {
                this.loadingError = err;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
